export default __webpack_public_path__ + "static/media/everlinkLogo.d6aa0f30.png";